<template>
	<form class="w-100">
		<fieldset>
			<!-- transition between existing-question & create-new-question -->
			<transitionExpand>
				<!-- form for new question -->
				<newQuestion
					ref="newQuestionForm"
					:language="language"
					v-if="selected == 'CREATE_NEW'"
					key="new-question"
				>
					<!-- here comes the new question component -->
				</newQuestion>
				<!--/ form for new question -->

				<!-- new existing question -->
			</transitionExpand>

			<!-- select question -->
			<!-- loader questions -->
			<v-wait for="loading questions">
				<template slot="waiting">
					<b-form-row>
						<b-col cols="12">
							<b-form-group class="py-2">
								<b-spinner small variant="info" label="Spinning" role="status"></b-spinner>
								<small class="text-info pl-2">
									<em>fetching questions</em>
								</small>
							</b-form-group>
						</b-col>
					</b-form-row>
				</template>

				<!-- questions loaded -->
				<b-form-row>
					<b-col cols="12">
						<b-form-group class="mb-0" label="Select Question:" label-cols="12" label-align="left">
							<b-input-group>
								<!-- select question that are already in db or select to create new one-->
								<b-form-select v-model="selected" :options="questions" text-field="title" value-field="id">
									<template slot="first">
										<option value="CREATE_NEW">-- CREATE NEW ONE --</option>
									</template>
								</b-form-select>

								<!-- add question (execute store to db) -->
								<b-button
									variant="info"
									:disabled="selected== null||$wait.is('saving question')"
									class
									slot="append"
									@click.prevent="doCreateQuestion"
								>
									<v-wait for="saving question">
										<template slot="waiting">
											<div>
												<font-awesome-icon :icon="['fas', 'circle-notch']" spin />&nbsp;Adding...
											</div>
										</template>
										<font-awesome-icon icon="plus" title="create answer" fixed-width />&nbsp;
										Add Question
									</v-wait>
								</b-button>
							</b-input-group>
						</b-form-group>
					</b-col>
				</b-form-row>
			</v-wait>
		</fieldset>
	</form>
</template>

<script>
	import { mapActions } from "vuex";
	import newQuestion from "@/components/question/questionNewRow.vue";
	import transitionExpand from "@/components/utils/TransitionExpand.vue";

	export default {
		name: "AddNewQuestion_component",

		components: { newQuestion, transitionExpand },

		props: {
			questions: Array, // all availabe to choose from one of them
			language: Object,
			default: function() {
				return {};
			}
		},

		data: function() {
			return {
				form: {
					title: null,
					description: null,
					answers: []
				},
				selected: null
			};
		},

		methods: {
			// map vuex action to insert new question
			...mapActions("question", ["CREATE_QUESTION"]),

			// submmit question to parent (regionEdit component)
			doCreateQuestion() {
				this.$wait.start("saving question");

				// the new question is selected,
				// insert that question to db and return question-id
				if (this.selected == "CREATE_NEW") {
					// assign children form data
					this.form = this.$refs.newQuestionForm.form;
					this.form.language_id = this.language.id;

					// get the form data and submit it to backend
					this.CREATE_QUESTION({
						data: this.form
					}).then(
						question => {
							// pass question to region to update pivot table (region-question)
							this.$emit("questionAdded", question);
							this.resetForm();
						},
						error => {
							console.log("error creating the question: ", error);
							this.showToast("danger", error.statusText, error.data.message);
							this.$wait.end("saving question");
						}
					);

					// its one of existing question (exist in db)
				} else {
					// pass question to region to update pivot table (region-question)
					//this.$emit("questionAdded", this.questions.find({ id: this.selected }));
					this.$emit(
						"questionAdded",
						this.questions.find(({ id }) => id === this.selected)
					);

					this.resetForm();
				}
			},
			resetForm() {
				this.form = {
					title: null,
					description: null,
					answers: []
				};
				this.selected = null;
			}
		},

		// created hook
		created() {}
	};
</script>

<style scoped>
</style>
